import { createFeatureSelector, createSelector } from '@ngrx/store';
import { newPetFeatureKey } from '../new-pet-feature-key';
import { NewPetState } from '../new-pet.state';

const selectNewPet = createFeatureSelector<NewPetState>(newPetFeatureKey);

export const selectNewPetStep = createSelector(selectNewPet, (state) => state.step);
export const selectNewPetSteps = createSelector(selectNewPet, (state) => state.steps);
